<template>
  <div>
    <div v-if="this.loading">
      <b-spinner small v-if="this.loading"></b-spinner>
    </div>
    <div v-else>
      <p class="text-left sub-header mb-4">
        Csak azokat a kategóriákat látja, amelyek olyan termékeket tartalmaznak, amelyekre a cége adatai és a forrás
        felhasználás jellemzői alapján jogosult lehet.
      </p>
      <div v-if="touched && !this.subCategoryState" class="create-fund-error-message mb-3">
        Válasszon alkategóriát.
      </div>
      <b-row>
        <b-col xl="6" md="12" v-for="(item, index) in list" :key="item.id" class="my-3">
          <div class="categories-container">
            <FundMapMainCategory :mainCategory="item" :index="index" :isCategoryMap="false" />
          </div>
        </b-col>
      </b-row>
      <div class="d-flex align-item-start">
        <b-button class="btn mt-2 link-button btn-primary" @click="prev"> Vissza </b-button>
        <b-button class="btn ml-3 mt-2 link-button btn-primary" @click="next" variant="primary"> Tovább </b-button>
      </div>
      <FundMapCategoryMapRelocateBox />
    </div>
  </div>
</template>

<script>
import FundMapMainCategory from '../../../components/FundMapMainCategory.vue'
import FundMapCategoryMapRelocateBox from '../../../components/FundMapCategoryMapRelocateBox.vue'
import * as FundMapApi from '../../../api/fundMap'
import * as SearchObjectApi from '../../../api/searchObject'
import { mapGetters } from 'vuex'
import errorToast from '../../../mixins/toastError'
import * as userCompanyApi from '../../../api/userCompany'

export default {
  mixins: [errorToast],
  data() {
    return {
      list: [],
      selectedCompany: {},
      userCompanyOptions: [],
      touched: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'selectedFundMapCategory',
      'isAuthenticated',
      'fundMapCompany',
      'fundMapCompanyAttributes',
      'searchObjectId',
      'triggerNextButton'
    ]),
    subCategoryState() {
      if (this.touched) {
        return this.selectedFundMapCategory ? this.selectedFundMapCategory.subCategory.title.length > 0 : false
      } else {
        return null
      }
    }
  },
  components: {
    FundMapMainCategory,
    FundMapCategoryMapRelocateBox
  },
  methods: {
    scrollToTop() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
    fetchList: async function() {
      let isImaginaryCompany = false

      if (!this.fundMapCompany.imaginaryCompany) {
        isImaginaryCompany = false
      } else {
        isImaginaryCompany = true
      }

      if (isImaginaryCompany) {
        const imaginarySearchParamsToSend = {
          teaor: this.fundMapCompanyAttributes.teaor || this.selectedCompany.imaginaryCompany.mainTeaor,
          zip: this.fundMapCompanyAttributes.zip || this.selectedCompany.imaginaryCompany.address,
          revenue: this.selectedCompany.imaginaryCompany.income,
          balanceSheetTotal: this.selectedCompany.imaginaryCompany.balanceSheetTotal,
          latestExportRevenue: this.selectedCompany.imaginaryCompany.latestExportRevenue,
          head_count: this.selectedCompany.imaginaryCompany.headCount,
          isSupplier: this.fundMapCompanyAttributes.isSupplier,
          statisticalGFO: this.selectedCompany.imaginaryCompany.form,
          revenueFromAggriculture: this.fundMapCompanyAttributes.revenueFromAggriculture
        }

        const mainCategories = await FundMapApi.getMainCategoriesFilteredBySearchParams({
          companyId: this.selectedCompany.imaginaryCompany.companyId,
          searchParams: imaginarySearchParamsToSend
        })
        this.list = mainCategories
        if (mainCategories.length === 0) {
          return this.$store.dispatch('nextStepAction')
        }
      } else {
        let searchParamsToSend = { ...this.fundMapCompanyAttributes }
        // 'address' is necessary due to data reload on step 1, but we should not send it to BE
        if (this.fundMapCompanyAttributes.address) {
          delete searchParamsToSend['address']
        }
        const mainCategories = await FundMapApi.getMainCategoriesFilteredBySearchParams({
          companyId: this.selectedCompany.flaggerId,
          searchParams: searchParamsToSend
        })
        this.list = mainCategories
        if (mainCategories.length === 0) {
          return this.$store.dispatch('nextStepAction')
        }
      }
    },
    openLoginModal() {
      this.$root.$emit('bv::show::modal', 'login-modal')
    },
    addSearchObjectId(key, value) {
      this.$store.dispatch('setSearchObjectAction', { [key]: value })
    },
    prev() {
      this.scrollToTop()
      this.$store.dispatch('prevStepAction')
    },
    async next() {
      if (!this.selectedFundMapCategory) {
        this.touched = true
        this.errorToast('A továbblépéshez töltse ki a megjelölt mezőket!')
      }
      let isImaginaryCompany = false
      let isSelectedCompanyUserCompany = false

      if (!this.isAuthenticated) {
        return this.openLoginModal()
      }

      if (!this.fundMapCompany.imaginaryCompany) {
        isImaginaryCompany = false
      } else {
        isImaginaryCompany = true
      }

      try {
        this.userCompanyOptions = await userCompanyApi.getUserCompanies({})
      } catch (e) {
        console.log(e)
      }
      if (!isImaginaryCompany && this.userCompanyOptions.length > 0) {
        isSelectedCompanyUserCompany = !!this.userCompanyOptions.find(
          userCompany => userCompany.companyId === this.selectedCompany.flaggerId
        )
      } else {
        isSelectedCompanyUserCompany = false
      }

      if (isImaginaryCompany) {
        const imaginarySearchParamsToSend = {
          teaor: this.fundMapCompanyAttributes.teaor || this.selectedCompany.imaginaryCompany.mainTeaor,
          zip: this.fundMapCompanyAttributes.zip || this.selectedCompany.imaginaryCompany.address,
          revenue: this.selectedCompany.imaginaryCompany.income,
          balanceSheetTotal: this.selectedCompany.imaginaryCompany.balanceSheetTotal,
          latestExportRevenue: this.selectedCompany.imaginaryCompany.latestExportRevenue,
          head_count: this.selectedCompany.imaginaryCompany.headCount,
          isSupplier: this.fundMapCompanyAttributes.isSupplier || false,
          statisticalGFO: this.selectedCompany.imaginaryCompany.form,
          revenueFromAggriculture: this.fundMapCompanyAttributes.revenueFromAggriculture || false
        }
        await this.$store.dispatch('getFundMapCompetitionsAction', {
          companyId: this.selectedCompany.imaginaryCompany.companyId,
          searchParams: imaginarySearchParamsToSend,
          selectedSubCategory: this.selectedFundMapCategory.subCategory._id
        })

        const resp = await SearchObjectApi.saveSearchObjects({
          filters: imaginarySearchParamsToSend
        })
        this.addSearchObjectId('searchObjectId', resp._id)

        this.scrollToTop()
        return this.$store.dispatch('nextStepAction')
      } else {
        if (isSelectedCompanyUserCompany) {
          let searchParamsToSend = { ...this.fundMapCompanyAttributes }
          // 'address' is necessary due to data reload on step 1, but we should not send it to BE
          if (this.fundMapCompanyAttributes.address) {
            delete searchParamsToSend['address']
          }
          await this.$store.dispatch('getFundMapCompetitionsAction', {
            companyId: this.selectedCompany.flaggerId,
            searchParams: searchParamsToSend,
            selectedSubCategory: this.selectedFundMapCategory.subCategory._id
          })

          const resp = await SearchObjectApi.saveSearchObjects({
            filters: searchParamsToSend
          })
          this.addSearchObjectId('searchObjectId', resp._id)

          this.$store.dispatch('nextStepAction')
        } else {
          this.$router.push({
            path: '/add-company-private',
            query: { redir: `fund-map/search?${this.selectedCompany.flaggerId}` }
          })
        }
      }
    }
  },
  async created() {
    this.selectedCompany = this.fundMapCompany
    this.userCompanyOptions = this.userCompanies
    await this.fetchList()

    if (this.triggerNextButton) {
      this.loading = true
      this.$store.dispatch('toggleTriggerNextButtonAction')
      this.next()
    }
  }
}
</script>

<style lang="scss" scoped>
.categories-container {
  cursor: pointer;
  min-height: 50px;
  padding: 24px;
  border: 1px solid #b2bec3;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(99, 110, 114, 0.2);
}

.sub-header {
  font-weight: 500;
  font-size: 12px;
}

.btn-primary {
  min-width: 150px;
}

.create-fund-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 20px;
}
</style>
